import { Box, Button, Icon, Typography } from "@outschool/backpack";
import { ChildFragmentFragment } from "@outschool/gql-frontend-generated";
import { faChevronRight } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import { AvatarImage, DEFAULT_AVATAR } from "@outschool/ui-components-shared";
import React from "react";
export default function LearnerSwitcher({
  learners,
  selectedLearner,
  setSelectedLearner,
}: {
  learners: ChildFragmentFragment[];
  selectedLearner: ChildFragmentFragment;
  setSelectedLearner: (learner: ChildFragmentFragment) => void;
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\subcomponents\\LearnerSwitcher",
  );
  const [isLearnerOpen, setIsLearnerOpen] = React.useState<any>(false);

  const handleLearnerMenu = () => {
    setIsLearnerOpen(!isLearnerOpen);
  };

  const handleSelectLearner = (learner: any) => {
    setSelectedLearner(learner);
    setIsLearnerOpen(false);
  };
  return (
    <Box>
      <Button
        aria-controls="learner-menu"
        onClick={handleLearnerMenu}
        variant="outlined"
        color="primary"
        size="medium"
        sx={{ width: "100%" }}
      >
        {t("Learner:")} {selectedLearner?.name}
        <Icon
          sx={{ fontSize: "14", marginLeft: "4px" }}
          icon={faChevronRight}
        />
      </Button>
      {isLearnerOpen && (
        <Box
          sx={{
            backgroundColor: "grey.50",
            borderRadius: "8px",
            marginTop: 8,
            paddingLeft: 8,
          }}
        >
          {learners.map(learner => (
            <Box
              key={learner.uid}
              onClick={() => handleSelectLearner(learner)}
              sx={{
                height: "48px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box flex sx={{ alignItems: "center" }}>
                <AvatarImage
                  avatar={learner.avatar || DEFAULT_AVATAR}
                  width={32}
                  height={32}
                  name={learner.name}
                  sx={{ mr: "0.5em" }}
                />
                <Typography variant={"body1"}>{learner.name}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

export function useGetLearners() {
  const { currentUser, currentUserHasLoaded } = useSession();
  const learners =
    currentUserHasLoaded && currentUser?.children
      ? [...currentUser.children].sort((a, b) => {
          const ageA = a.age || 0;
          const ageB = b.age || 0;
          return ageA - ageB;
        }) || []
      : [];
  return learners;
}
